var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditPortfolioItem.jinja');
require('./MemberProfileEditPortfolioItem.less');

require('jquery-ui/ui/widgets/sortable');

module.exports = Base.extend({

    template: template,

    events: {
        'blur .MemberProfileEditPortfolioItem-inputWrapper-info-inputEmbed': 'onVideoCodeBlur',
        'keyup .MemberProfileEditPortfolioItem-inputWrapper-info-inputEmbed': 'onVideoCodeKeyUp',
        'change input[name="cover"]': 'changeImage',
        'click .MemberProfileEditPortfolioItem-inputIcons-delete': 'deleteItem',
        'click .MemberProfileEditPortfolioItem-info': 'onInfoClick'
    },


    tempFilesApi: function () {
        return (Urls['front:api:files:temp-file-upload']());
    },


    embedApi: function () {
        return (Urls['front:api:oembed']());
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this,  'tempFilesApi', 'embedApi', 'onBodyClick');

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

    },


    deactivate: function (params) {
        this.imageXHR && this.imageXHR.abort();

        this.videoXHR && this.videoXHR.abort();

        return Base.prototype.deactivate.call(this, params);
    },


    onInfoClick: function (e) {
        if (app.settings.isDesktop) return;

        if ($(e.target).closest('.MemberProfileEditPortfolioItem-infoPopup').length) return;

        if ($(e.currentTarget).hasClass('MemberProfileEditPortfolioItem-info--active')) {
            this.closeAllInfoPopups();
        } else {
            this.closeAllInfoPopups();
            $(e.currentTarget).addClass('MemberProfileEditPortfolioItem-info--active');
            $('body').on('click', this.onBodyClick);
        }
    },


    closeAllInfoPopups: function () {
        this.$('.MemberProfileEditPortfolioItem-info').removeClass('MemberProfileEditPortfolioItem-info--active');

        $('body').off('click', this.onBodyClick);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.MemberProfileEditPortfolioItem-info').length) return;

        this.closeAllInfoPopups();
    },


    onVideoCodeBlur: function (e) {
        this.getVideoInfo();
    },


    onVideoCodeKeyUp: function (e) {
        if (e.keyCode == 13) {
            this.$('.MemberProfileEditPortfolioItem-inputWrapper-info-inputCaption').focus();
        }
    },


    getVideoInfo: function () {
        var $inputUrl = this.$('.MemberProfileEditPortfolioItem-inputWrapper-info-inputEmbed');
        var $loader = this.$('.MemberProfileEditPortfolioItem-inputLoader');
        var $img = this.$('.MemberProfileEditPortfolioItem-inputWrapper-imageWrapper img');
        var $inputCover = this.$('input[name="cover"]');
        var $inputProvider = this.$('input[name="videoProvider"]');
        var $inputCode = this.$('input[name="videoCode"]');

        $loader.show();

        this.videoXHR && this.videoXHR.abort();

        $inputProvider.val('');
        $inputCode.val('');

        $img.attr('src', '');
        $inputCover.attr('data-file', '');

        this.videoXHR = $.ajax({
            type: 'GET',
            url: this.embedApi(),
            dataType: 'json',
            data: {url: $inputUrl.val()},
            success: function (data) {
                if (!data || data.error) {
                    $loader.hide();

                    return;
                }

                $inputProvider.val(data.provider);
                $inputCode.val(data.code);

                $img.attr('src', data.cover.w680_url);
                $inputCover.attr('data-file', JSON.stringify(data.cover));
                $loader.hide();
            },
            error: function () {
                console.log(arguments);
                $loader.hide();
            }
        });
    },


    changeImage: function (e) {
        if (!e.target.files || !e.target.files.length) return;

        this.imageXHR && this.imageXHR.abort();

        var $input = $(e.currentTarget);
        var $loader = this.$('.MemberProfileEditPortfolioItem-inputLoader');
        var $label = this.$('.MemberProfileEditPortfolioItem-inputChange');
        var $img = this.$('.MemberProfileEditPortfolioItem-inputWrapper-imageWrapper img');
        var fil = e.target.files[0];
        var self = this;

        $input.attr('data-file', '');

        $loader.show();
        $label.hide();

        this.imageXHR = new XMLHttpRequest();
        this.imageXHR.open('POST', this.tempFilesApi());

        this.imageXHR.onload = function (res, data) {
            var responseObject = app.AdoptTempFileObject(this.responseText, 'image');

            $input.attr('data-file', JSON.stringify(responseObject));

            $loader.hide();
            $label.show();

            $img.attr('src', responseObject.tempImg);
        };

        this.imageXHR.onerror = function () {
            $img.removeAttr('src');

            $loader.hide();
            $label.show();
        };

        var formData = new FormData();
        formData.append('file', fil);
        this.imageXHR.send(formData);

        $input.val('');
    },


    deleteItem: function (e) {
        this.deactivate();

        this.remove();

        window.app.vent.trigger('MemberProfileEditPortfolioItem-remove');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolioItem.js
// module id = 213
// module chunks = 0